import { EventEmitter } from './EventEmitter';
import { FrameworkEvent } from './FrameworkEvent';

function camelCase(input) {
    return input.replace(/\.(.)/g, (match, group1) => group1.toUpperCase());
}

let _actionList = ['default'];
const _eventEmitter = new EventEmitter();

export class AppEvents {
    constructor(schema) {
        const _schema = schema || {};

        // Set an option in the schema
        const setSchemaOption = (option, value, label) => {
            _schema[option] = value;
            if (label) {
                _schema.label = label;
            }

            return this;
        };

        // Map all actions to the object
        _actionList.map((action) => {
            const propName = camelCase(action);
            Object.defineProperty(this, propName, {
                value(label) {
                    return setSchemaOption('action', action, label);
                },
                enumerable: true,
            });
        });

        // Get a copy of the schema
        this.getSchema = () => Object.freeze(Object.assign({}, _schema));
    }

    static category(category) {
        return new AppEvents({ category });
    }

    static get actionList() {
        return _actionList.slice(0);
    }

    static set actionList(list) {
        if (!Array.isArray(list)) {
            throw (new TypeError('Action list must be an array of strings'));
        }
        _actionList = list;
    }

    static hasListener(event, handler) {
        return _eventEmitter.hasListener(event, handler);
    }

    get schema() {
        return this.getSchema();
    }

    get item() {
        return this.schema.label || null;
    }

    listen(handler) {
        const label = camelCase(`${this.schema.category}.${this.schema.action}`);
        _eventEmitter.on(label, handler);
        return this;
    }

    fire() {
        const label = camelCase(`${this.schema.category}.${this.schema.action}`);
        _eventEmitter.emit(new FrameworkEvent(label, this));
        return this;
    }

    remove(handler) {
        const label = camelCase(`${this.schema.category}.${this.schema.action}`);
        _eventEmitter.removeEventListener(label, handler);
        return this;
    }
}
